import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ServicesPage from './pages/Services';
import AboutPage from './pages/About';
import Careers from './pages/Careers';
import FAQ from './components/FAQ';
import ScrollToTop from './components/ScrollToTop';
import ContactModal from './components/ContactModal';
import BookingModal from './components/BookingModal';
import ServiceChangeModal from './components/ServiceChangeModal';
import './styles/main.scss';
import './App.css';

function AppContent() {
  const location = useLocation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [isServiceChangeModalOpen, setIsServiceChangeModalOpen] = useState(false);

  useEffect(() => {
    // Show modal on landing page (home) load every time
    if (location.pathname === '/' || location.pathname === '') {
      const timer = setTimeout(() => {
        setIsServiceChangeModalOpen(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  const handleContactClick = (e) => {
    if (e) e.preventDefault();
    setIsBookingModalOpen(false);
    setIsContactModalOpen(true);
  };

  const handleBookClick = () => {
    setIsContactModalOpen(false);
    setIsBookingModalOpen(true);
  };

  const closeContactModal = () => {
    setIsContactModalOpen(false);
    setIsBookingModalOpen(false);
  };

  const closeBookingModal = () => {
    setIsBookingModalOpen(false);
    setIsContactModalOpen(false);
  };

  const closeServiceChangeModal = () => {
    setIsServiceChangeModalOpen(false);
  };

  return (
    <>
      <Header 
        onContactClick={handleContactClick}
        onBookClick={handleBookClick}
      />
      <Routes>
        <Route exact path="/" element={
          <Home 
            onContactClick={handleContactClick}
            onBookClick={handleBookClick}
          />
        } />
        <Route path="/services" element={
          <ServicesPage 
            onContactClick={handleContactClick}
            onBookClick={handleBookClick}
          />
        } />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/faq" element={
          <main>
            <div className="faq-page">
              <FAQ />
            </div>
          </main>
        } />
      </Routes>
      <Footer />
      <ContactModal 
        isOpen={isContactModalOpen}
        onClose={closeContactModal}
      />
      <BookingModal
        isOpen={isBookingModalOpen}
        onClose={closeBookingModal}
      />
      <ServiceChangeModal
        isOpen={isServiceChangeModalOpen}
        onClose={closeServiceChangeModal}
      />
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <AppContent />
      </div>
    </Router>
  );
}

export default App; 